/**
 * Which locales the search type-ahead is enabled for (RAS-2536 / RAS-2616).
 *
 * Shared deliberately between client and server, in the same CommonJS style as
 * translatedRoutePaths.js: the extraction side (server/api-util/searchTerms.js) must not write
 * terms for a locale the lookup side (src/util/algoliaSuggestions.js) will never query, and a
 * duplicated constant would silently drift.
 *
 * English, French and Spanish. Titles are translated in all three (99%+ in production), and
 * the extractor now carries per-locale rules: French and Spanish are head-INITIAL, so the
 * modifier check applies to the first word rather than the last, and they agree in number
 * across a noun phrase so every word is singularised together.
 *
 * Roughly half of French and Spanish `alternative_search_titles` are still English in
 * production, so some English phrasing will appear until the enrichment microservice
 * translates that field. Titles carry the load meanwhile.
 *
 * Chinese stays off: CJK cannot be whitespace-tokenised, so it yields nothing without a
 * segmentation dictionary.
 *
 * To enable a locale: add it here, confirm its source text is genuinely translated, then run
 * server/scripts/backfill-search-terms.js for that index.
 */
const SUGGESTION_LOCALES = ['en', 'fr', 'es'];

const isSuggestionLocale = locale =>
  SUGGESTION_LOCALES.includes(String(locale || '').toLowerCase());

module.exports = { SUGGESTION_LOCALES, isSuggestionLocale };
